// extracted by mini-css-extract-plugin
export default {"app":"Coupon_app__UCm9S","headerBar":"Coupon_headerBar__-uXW4","view":"Coupon_view__n6MiG"};